import React, { useState } from "react";
import "./Booking.css";
import emailjs from "@emailjs/browser";
import Footer from "../../components/Footer/Footer"; // ⬅️ added

// EmailJS constants (Lessons)
const SERVICE_ID = "service_rnqp5dd";
const LESSONS_ADMIN_TEMPLATE_ID = "template_qupsreg"; // Lessons Form (admin)
const LESSONS_AUTOREPLY_TEMPLATE_ID = "template_g7i1e7y"; // Auto-Reply Lessons Form
const PUBLIC_KEY = "QKlnswpeeF5706uvk";

const Booking = () => {
  const [sending, setSending] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    instrument: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData((s) => ({ ...s, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatusMessage("");

    const payload = {
      name: formData.name,
      phone: formData.phone,
      email: formData.email,
      instrument: formData.instrument,
      message: formData.message,
      to_email: "ivan@melodiamusicllc.com", // admin recipient
    };

    try {
      // 1) Admin must succeed
      await emailjs.send(
        SERVICE_ID,
        LESSONS_ADMIN_TEMPLATE_ID,
        payload,
        PUBLIC_KEY
      );

      // 2) Auto-reply is best-effort (never block success UI)
      try {
        await emailjs.send(
          SERVICE_ID,
          LESSONS_AUTOREPLY_TEMPLATE_ID,
          { ...payload, to_email: formData.email }, // template uses {{to_email}}
          PUBLIC_KEY
        );
      } catch (autoErr) {
        console.warn("Lessons auto-reply failed:", autoErr);
      }

      setStatusMessage(
        "Thank you! Your request has been received. I’ll reach out shortly to discuss scheduling, pricing, and next steps."
      );
      setFormData({
        name: "",
        phone: "",
        email: "",
        instrument: "",
        message: "",
      });
    } catch (err) {
      setStatusMessage(
        "There was an error submitting the form. Please try again."
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <section id="booking" className="booking-section">
        <h2>Request a Lesson</h2>
        <p className="booking-intro">
          Ready to get started? Fill out the form below and I'll personally
          follow up to discuss scheduling, pricing, and lesson options tailored
          to you.
        </p>

        <div className="booking-form-container">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <select
              name="instrument"
              value={formData.instrument}
              onChange={handleChange}
              required
            >
              <option value="">-- Select an Instrument --</option>
              <option value="Piano (1:1)">Piano (1:1)</option>
              <option value="Guitar (1:1)">Guitar (1:1)</option>
              <option value="Bass (1:1)">Bass (1:1)</option>
              <option value="Drums (1:1)">Drums (1:1)</option>
              <option value="Trumpet (1:1)">Trumpet (1:1)</option>
              <option value="Tracks & Software (Logic, Ableton, MainStage)">
                Tracks &amp; Software (Logic, Ableton, MainStage)
              </option>
              <option value="Audio Engineering Training (Live/DAW)">
                Audio Engineering Training (Live/DAW)
              </option>
            </select>

            <textarea
              name="message"
              placeholder="Additional Info (optional) — in-person (San Jose) or Zoom, goals, experience, preferred times"
              value={formData.message}
              onChange={handleChange}
              rows="5"
            />

            <button type="submit" disabled={sending}>
              {sending ? "Sending..." : "Submit Request"}
            </button>

            {statusMessage && <p className="status">{statusMessage}</p>}
          </form>
        </div>
      </section>
      <Footer /> {/* ⬅️ added */}
    </>
  );
};

export default Booking;
